import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "The Parser Projection",
description: "Learn how Freon generates parsers and unparsers from the default or dedicated parser projection, how they handle layout, and how to avoid common parsing issues.",
tags: [ "parser projection", "unparser", "file reader", "file writer", "AGL", "parser generator", "projectional editor", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T17:20:18.610Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};